import {
    CREATE_AGENT_COLOURS_URL,
    GET_AGENT_COLOURS_URL,
    UPDATE_AGENT_COLOURS_URL,
    GET_AGENT_COLOUR_THEMES_URL
} from "../utils/api-url";
import { postCall } from "../utils/network.util";
import {CREATE_AGENT_COLOURS, GET_AGENT_COLOURS, UPDATE_AGENT_COLOURS, GET_AGENT_COLOUR_THEMES } from "./action-types";

export const getAgentColorDetails = (operatorCode, onSuccess=()=>{}, onFailure=()=>{}) => {
    return {
        type: GET_AGENT_COLOURS,
        payload: {
            url: GET_AGENT_COLOURS_URL,
            api: postCall,
            apiPayload: {
                operatorCode
            },
            onSuccess,
            onFailure
        }
    }
}

export const getAgentColorThemes = (onSuccess=()=>{}, onFailure=()=>{}) => {
    return {
        type: GET_AGENT_COLOUR_THEMES,
        payload: {
            url: GET_AGENT_COLOUR_THEMES_URL,
            api: postCall,
            apiPayload: {},
            onSuccess,
            onFailure
        }
    }
}

export const createAgentColors = (operatorCode, colorData, onSuccess = () => {}, onFailure = () => {}) => {
    return {
        type: CREATE_AGENT_COLOURS,
        payload: {
            url: CREATE_AGENT_COLOURS_URL,
            api: postCall,  
            apiPayload: {
                operatorCode,
                data: colorData
            },
            onSuccess,
            onFailure
        }
    }
}

export const updateAgentColors = (operatorCode, colorData, onSuccess = () => {}, onFailure = () => {}) => {
    return {
        type: UPDATE_AGENT_COLOURS,
        payload: {
            url: UPDATE_AGENT_COLOURS_URL,
            api: postCall,
            apiPayload: {
                operatorCode,
                data: colorData
            },
            onSuccess,
            onFailure
        }
    }
}